import Sidebar from "./Sidebar";
import ListCard from "./ListCard";

import { Container, Row } from "reactstrap";
import CandidateSearchProvider from "../../../CandidateSearch/CandidateSearchContext";


const CandidateSearch = () => {
  console.log("Parent Component rendered");
  return (
    <Container fluid={true}>
      <Row className="mb-5">
       
          
          <Sidebar />
          <ListCard />
        
      </Row>
    </Container>
  );
};

export default CandidateSearch;
